import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-authentication';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Authentication 101: How it Works and Why Does it Matter</title>
        <meta
          name='description'
          content='Learn how Grailed authentication works, why having your items digitally authenticated matters, and how to get more money by selling your authentic items on Grailed.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-authentication' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-authentication' />
        <meta property='og:title' content='Grailed Authentication 101: How it Works and Why Does it Matter' />
        <meta
          property='og:description'
          content='Learn how Grailed authentication works, why having your items digitally authenticated matters, and how to get more money by selling your authentic items on Grailed.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
